module.exports = __webpack_public_path__ + "static/media/pecuaria-2.592a94ed.jpg";